import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';

const modalRoot = document.getElementById('toast-root');

function ToastCloseButton({ closeToast, type }) {
    return (
        <button
            className={`Toastify__close-button Toastify__close-button--${type}`}
            type="button"
            aria-label="close"
            onClick={event => {
                event.stopPropagation();
                closeToast(event);
            }}
        >
            {'\u2716\uFE0E'}
        </button>
    );
}

class ToastPortalContainer extends Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            <ToastContainer
                draggable={false}
                position="top-right"
                autoClose={15000}
                hideProgressBar={true}
                theme="light"
                icon={false}
                closeButton={ToastCloseButton}
            />,
            this.el,
        );
    }
}

export default ToastPortalContainer;
